export const maxWidth = '38rem'
